import React from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import PdfIcon from '../../../../assets/img/PdfIcon.svg'
import Modal from 'antd/es/modal';
import { useHistory } from 'react-router-dom'
import { Container } from '@material-ui/core'

const WorkOrderDetails = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()

    const changeStateBody = {
        "woid": props.workDetail[0].woid,
        "stageID": props.workDetail[0].collateralStageID + 1,
        "BranchOfficeId": parseInt(props.match.params.branchOfficeId)
    }

    const handleEndState = () => {
        props.actions.change_State(props.userLanguage, props.userToken, changeStateBody, onErrorEndOt, onSuccessEndOt)
    }

    const handleDownload = () => {
        props.actions.Download_Work_Order_PDF(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.woid)
    }

    const onSuccessEndOt = (res) => {
        if (res.success === false) {
            Modal.error({
                title: 'Error',
                content: t('collateralDetails.' + res.message)
            })
        } else {
            Modal.success({
                content: t('collateralDetails.concludeOTMssg')
            })
            history.push(`/collateral/${props.match.params.branchOfficeId}`)
        }
    }

    const onErrorEndOt = () => {
        Modal.error({
            title: 'Error',
            content: t('collateralDetails.errorOT')
        })
    }

    return (
        <div>
            <Container className={classes.generalBorder}>
                <CardContent>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                    >
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.numberWoid')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].woid}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.fleet')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].fleet}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.plates')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].plate}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }} >{t('common.year')}</Typography>
                            <Typography variant="body2" >{props.workDetail[0].modelYear}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardContent>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start" >
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }} >{t('common.AssignedDate')}</Typography>
                            <Typography variant="body2" >{props.workDetail[0].assignedSupplierDate}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.unit')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].unitNumber}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.model')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].make}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>VIN</Typography>
                            <Typography variant="body2">{props.workDetail[0].vinNumber}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardContent>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                    >
                        {
                            props.workDetail.length && props.workDetail[0].collateralStageID !== 3 && (
                                <Grid item xs={3}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.endDate')}</Typography>
                                    <Typography variant="body2">{props.workDetail[0].endDate}</Typography>
                                </Grid>
                            )
                        }
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.status')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].woStatus}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('collateralDetails.assignedArea')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].assignedArea}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('collateralDetails.applicantName')}</Typography>
                            <Typography variant="body2">{props.workDetail[0].assignedUser}</Typography>
                        </Grid>
                        {
                            props.workDetail.length && props.workDetail[0].collateralStageID === 3 && (
                                <Grid item xs={3}>

                                </Grid>
                            )
                        }
                    </Grid>
                </CardContent>
                <Divider />
                <br />
                {props.workDetail[0].collateralStageID === 4
                    ?
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="flex-end"
                    >
                        <Grid item xs={8}>
                            <br />
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleEndState} className={classes.generalBorder} variant="outlined">
                                {t('collateralDetails.endStage')}
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleDownload} className={classes.generalBorder} variant="outlined">
                                {t('commonMessages.dlPDF')}<img src={PdfIcon} alt="PDFIcon" width="24" height="24" />
                            </Button>
                        </Grid>
                    </Grid>
                    :
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="flex-end"
                    >
                        <Grid item xs={8}>
                            <br />
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleDownload} className={classes.generalBorder} variant="outlined">
                                {t('commonMessages.dlPDF')}&nbsp;<img src={PdfIcon} alt="PDFIcon" width="24" height="24" />
                            </Button>
                        </Grid>
                    </Grid>
                }
                <br />
            </Container>
        </div>
    )
}

export default (withStyles(CollateralStyles)(WorkOrderDetails))
